"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueSetResolver = void 0;
const axios_1 = __importDefault(require("axios"));
const VSACHelper_1 = require("./VSACHelper");
class ValueSetResolver {
    constructor(apiKey) {
        this.apiKey = apiKey;
        this.instance = axios_1.default.create({
            headers: {
                Accept: 'application/fhir+json',
                Authorization: `Basic ${this.authHeaderValue()}`
            },
            // Timeout is in ms, not seconds
            timeout: 60000,
            withCredentials: true
        });
    }
    authHeaderValue() {
        return Buffer.from(`apikey:${this.apiKey}`).toString('base64');
    }
    async getExpansionForValuesetUrls(urls) {
        const valuesets = [];
        const errors = [];
        // Make the actual requests. We use 'for.. of' here because we want to send requests individually
        // to avoid 500 errors on VSAC
        for (const url of urls) {
            // Go through the results and find any that failed.
            // If there are failures, build an error string
            let normalizedUrl = url;
            try {
                // Use known good base for VSAC urls
                if ((0, VSACHelper_1.isVSACUrl)(url)) {
                    normalizedUrl = (0, VSACHelper_1.normalizeCanonical)(url) || url;
                }
                const res = await this.instance.get(`${normalizedUrl}/$expand`);
                valuesets.push(res.data);
            }
            catch (e) {
                if (e instanceof Error) {
                    errors.push(`Valueset with URL ${normalizedUrl} could not be retrieved. Reason: ${e.message}`);
                }
                else {
                    errors.push(`Valueset with URL ${normalizedUrl} could not be retrieved. Reason: ${String(e)}`);
                }
            }
        }
        // If we couldn't retrieve any valuesets, return and let the user know
        if (errors.length > 0) {
            return [valuesets, errors];
        }
        // Check to make sure we have all the valueset URLs we think we're going to
        const missingValuesets = this.findMissingValuesets(urls, valuesets);
        return [valuesets, missingValuesets];
    }
    findMissingValuesets(missingVSURLs, expansions) {
        const stillMissingValuesets = [...missingVSURLs];
        // remove any valuesets we got from their URLs from the "missing" list
        expansions.forEach(vs => {
            if (vs.url) {
                const index = stillMissingValuesets.indexOf(vs.url);
                if (index > -1) {
                    stillMissingValuesets.splice(index, 1);
                }
            }
        });
        return stillMissingValuesets;
    }
}
exports.ValueSetResolver = ValueSetResolver;
//# sourceMappingURL=ValueSetResolver.js.map